<template>
  <div>
    <div class="tree-view-item" @click="nodeClickHandle">
      <b-icon :icon="statusIcon" type="is-small" />
      <a @click.stop="checkItemHandle">
        <b-icon :icon="checkIcon" pack="far" :type="checkColor" />
      </a>
      <label class="node-text">{{ item.title }}</label>
    </div>
    <div v-if="isOpen" class="tree-view-node">
      <div class="tree-view-node">
        <tree-view-item
          v-for="child in item.children"
          :key="`option-item-${child.id}`"
          :item="child"
          :level="level + 1"
          @check="checkOptionHandle"
          @open="openNodeHandle"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TreeViewItem',
  props: {
    item: {
      type: Object,
      required: true
    },
    level: {
      type: Number,
      default: 0
    },
    checkHandle: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      isLoading: false,
      isOpen: false
    }
  },
  computed: {
    isIndeterminated() {
      return false
    },
    hasChildren() {
      return this.item.children && this.item.children.length > 0
    },
    statusIcon() {
      return this.isOpen ? 'angle-down' : 'angle-right'
    },
    checkIcon() {
      let allChildrenSelected = true
      // Si tiene hijos, se valida si todos están seleccionados
      if (this.hasChildren)
        allChildrenSelected = this.item.children.every((item) => item.selected)
      let icon = 'square' // 'checkbox-blank-outline'
      if (this.item.selected)
        if (allChildrenSelected) icon = 'check-square'
        // 'checkbox-marked-outline'
        else icon = 'minus-square' // 'checkbox-blank'
      return icon
    },
    checkColor() {
      return this.item.selected ? 'is-info' : 'is-black'
    }
  },
  watch: {
    isLoading(newVal) {
      if (!newVal && this.children.length === 0) {
        this.isOpen = false
      }
    }
  },
  methods: {
    async nodeClickHandle() {
      const self = this
      self.isOpen = !self.isOpen
      await self.$nextTick(() => {
        self.$emit('open', { id: self.item.id, level: self.level })
      })
    },
    async openNodeHandle(payload) {
      const self = this
      await self.$nextTick(() => {
        self.$emit('open', {
          id: self.item.id,
          level: self.level,
          children: payload
        })
      })
    },
    async checkItemHandle() {
      const self = this
      const selected = !self.item.selected
      await self.$nextTick(() => {
        self.$emit('check', {
          id: self.item.id,
          selected: selected,
          level: self.level
        })
      })
    },
    async checkOptionHandle(payload) {
      const self = this
      await self.$nextTick(() => {
        self.$emit('check', {
          id: self.item.id,
          selected: payload.selected,
          level: self.level,
          children: payload
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.tree-view-node {
  display: block;
  margin: 2px 0;
  padding-left: 0.75em;
}

.tree-view-item {
  display: flex;
  flex-direction: row;
  align-items: center;

  .loading-node {
    height: 1em;
  }

  .node-text {
    padding-left: 6px;
  }
}
</style>
